<template>
  <v-dialog
    persistent
    v-model="dialogDeleteConfirm"
    :width="screenWidth + '%'"
  >
    <div class="container-dialog">
      <close-dialog-component @closeDialog="closeDialog" />
      <p class="text-title mon-bold">{{ title }}</p>
      <div class="display-flex align-items-center justify-content-center">
        <img
          width="90px"
          src="@/assets/icons/delete.png"
          alt=""
        >
      </div>
      <p
        class="text-description mon-regular mt-2"
        v-html="description"
      />
      <p class="text-subdescription mon-regular">{{ subdescription }}</p>
      <div class="display-flex align-items-center justify-content-center">
        <v-checkbox
          v-model="deleteConfimation"
          class="text-confirmation mon-regular"
          :label="confirmation"
        ></v-checkbox>
      </div>
      <div v-if="isResponsive">
        <v-btn
          class="button-primary mon-bold"
          elevation="0"
          :disabled="!deleteConfimation"
          @click="deleteItem"
          :loading="bLoading"
          style="width: 100%;"
        >
          {{ texts.deleteconfirm.textButtonDelete }}
        </v-btn>
        <v-btn
          class="button-secondary mon-regular mt-5"
          elevation="0"
          @click="closeDialog"
          style="width: 100%;"
        >
          {{ texts.deleteconfirm.textButtonCancel }}
        </v-btn>
      </div>
      <div
        v-else
        class="display-flex align-items-center justify-content-center mt-9"
      >
        <v-btn
          class="button-secondary mon-regular"
          elevation="0"
          @click="closeDialog"
        >
          {{ texts.deleteconfirm.textButtonCancel }}
        </v-btn>
        <v-btn
          class="button-primary mon-bold ml-5"
          elevation="0"
          :disabled="!deleteConfimation"
          @click="deleteItem"
          :loading="bLoading"
        >
          {{ texts.deleteconfirm.textButtonDelete }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteConfirmComponent",
  data() {
    return {
      texts: "",
      title: "",
      description: "",
      subdescription: "",
      confirmation: "",
      api: "",
      redirect: "",
      deleteConfimation: false,
      bLoading: false,
      screenWidth: 0,
      isResponsive: false,
    };
  },
  beforeMount() {
    this.texts = FILE.deleteconfirm[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    closeDialog: function () {
      this.$store.commit("setDialogDeleteConfirm", {
        active: false,
        obj: {},
      });
    },
    deleteItem: function () {
      this.bLoading = true;

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.delete(`${this.api}`, config)
        .then((response) => {
          this.bLoading = false;

          this.closeDialog();
          this.mixSuccess(response.data.message);
          if (this.redirect !== "") {
            this.$router.push(this.redirect);
          }
          this.$store.commit("refresher", true);
        })
        .catch((error) => {
          this.bLoading = false;

          this.closeDialog();
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 50;
      } else {
        this.screenWidth = 100;
      }

      if (window.innerWidth < 960) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
  },
  computed: {
    // return create contact dialog state
    dialogDeleteConfirm() {
      return this.$store.state.dialogDeleteConfirm;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    dialogDeleteConfirm() {
      if (this.dialogDeleteConfirm) {
        let store = this.$store.state;

        this.title = store.dialogDeleteConfirmObj.title;
        this.description = store.dialogDeleteConfirmObj.description;
        this.subdescription = store.dialogDeleteConfirmObj.subdescription;
        this.confirmation = store.dialogDeleteConfirmObj.confirmation;
        this.api = store.dialogDeleteConfirmObj.api;
        this.redirect = store.dialogDeleteConfirmObj.redirect;
      }
    },
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.deleteconfirm[this.selectLanguage];
      }
    },
  },
};
</script>

<style>
.text-confirmation label {
  text-align: left;
  font-size: 12px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
}
</style>

<style scoped>
.text-subdescription {
  text-align: center;
  font-size: 12px;
  letter-spacing: 0px;
  color: #d8686a;
  opacity: 1;
}

.container-dialog {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
  padding: 25px;
  position: relative;
}

.text-title {
  text-align: center;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  font-size: 20px;
}

.text-description {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
}
</style>